import { FormikHelpers } from "formik";
import { useState } from "react";
import { IMailingForm } from "../components/mailingListForm";
import { getMailingFormSchema } from "../utils/getMailingFormSchema";
import { useSubscribeToMailChimpMutation } from "@sendsprint/apis/queries/b2c";
import { ProjectApi } from "@/types";
import { AxiosError } from "axios";

export interface UseMailingListResponse {
  postSubmitState:
    | ProjectApi.B2CAccount.NewsletterSubscribe.Response
    | undefined;
  handleSubmit: (
    values: IMailingForm,
    formikHelpers: FormikHelpers<IMailingForm>,
  ) => Promise<void>;
  isPending: boolean;
  validationSchema: any;
  handleResetPostSubmitState: () => void;
}

const useMailingList = (): UseMailingListResponse => {
  const [postSubmitState, setPostSubmitState] =
    useState<ProjectApi.B2CAccount.NewsletterSubscribe.Response>();

  const { mutateAsync, isPending } = useSubscribeToMailChimpMutation();

  const handleResetPostSubmitState = () => {
    setPostSubmitState(undefined);
  };

  const handleSubmit = async (
    values: IMailingForm,
    formikHelpers: FormikHelpers<IMailingForm>,
  ) => {
    try {
      const nameArr = values.name.split(" ");

      await mutateAsync({
        Email: values.email,
        FirstName: nameArr[0],
        LastName: nameArr[1] || "",
        Country: "General",
      });

      setPostSubmitState("SUCCESS");
    } catch (error: any) {
      const previousMember = error?.Data?.includes("Member Exists");

      setPostSubmitState(previousMember ? "EXISTS" : "ERROR");
    }
  };

  const validationSchema = getMailingFormSchema();

  return {
    postSubmitState,
    handleSubmit,
    isPending,
    validationSchema,
    handleResetPostSubmitState,
  };
};

export default useMailingList;
